import { render } from "./EUTermsAndConditionPage.vue?vue&type=template&id=79615702&scoped=true&ts=true"
import script from "./EUTermsAndConditionPage.vue?vue&type=script&lang=ts"
export * from "./EUTermsAndConditionPage.vue?vue&type=script&lang=ts"

import "./EUTermsAndConditionPage.vue?vue&type=style&index=0&id=79615702&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/rontend-vue_version_release-euau/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79615702"]])

export default __exports__